import { configAxios, configAxiosQuotation } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const getSlug = async (slug) => {
    const api = configAxios();
    const { data } = await api.get(`${ENDPOINTS.DIGITAL_MARKETING_APP}${slug}`);
    return data;
};

export const adwordNotification = async (payload) => {
    const api = configAxiosQuotation();
    await api.post(ENDPOINTS.ADWORDS_ALERT, payload);
};
export const getPhonesLocation = async () => {
    const api = configAxios();
    const { data } = await api.get(ENDPOINTS.PHONES_LOCATION);
    return data;
};
